
import classes from '@src/styles/Wordpress.module.css'
import { wordpressGroups } from "@src/constants/wordpress";
import Head from "next/head";
import WordpressPostSummary from './WordpressPostSummary';

function WordpressPostList ({ group, titleName, listTitle, data }: any) {
  const description = "";
  const titleGroup = wordpressGroups.blog.name;
  const title = `${titleName} - ${titleGroup} | Dimension Waste Management`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Head>
      <section>
        <div className={classes.listWrapper}>
          <div id="wordpress-post" />
          <div className={classes.root}>
            <a href={process.env.NEXT_PUBLIC_HOSTING_URL_PRIMARY}>Back to home</a>
            <h1>{listTitle}</h1>
            {Array.isArray(data) && data.map((post: any) => (
              <WordpressPostSummary group={group} post={post} key={post?.id ?? post?.slug} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WordpressPostList;
